import SearchDropdown from '../global-components/searchDropdown';

interface Props {
  id: string;
  options: any[];
  value: string | null;
  setValue: any;
  setHandleToggleChange?: any;
  dummyOptionText?: string;
  label?: string;
  required?: boolean;
}

export default function DropdownTemp({
  id,
  options,
  value,
  setValue,
  setHandleToggleChange,
  label,
  dummyOptionText,
  required = false,
}: Props) {
  return (
    <SearchDropdown
      id={id}
      required={required}
      selectedValue={value}
      label={label && label}
      options={options}
      onSelect={(item) => {
        setValue(item.value);
        setHandleToggleChange && setHandleToggleChange(true);
      }}
      dummyOptionText={dummyOptionText && dummyOptionText}
    />
  );
}
